import { render, staticRenderFns } from "./bought-episode-list.vue?vue&type=template&id=c856e1fa&scoped=true&"
import script from "./bought-episode-list.vue?vue&type=script&lang=js&"
export * from "./bought-episode-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c856e1fa",
  null
  
)

export default component.exports